import React, { useState, useEffect, Suspense } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { fetchDataTarget } from "../../helpers/target.ts";
import { fetchOverview } from "../../helpers/overview.ts";
import FilterBar from "../Filter/index.jsx";
import { getSavedLayouts } from "../../api/static/staticFiles.ts";
import { useSelector } from "react-redux";

const ResponsiveGridLayout = WidthProvider(Responsive);

const Dashboard = () => {
  //
  const { filter } = useSelector((state) => state.filter);
  const {
    selectedStart,
    selectedEnd,
    compareStart,
    compareEnd,
    selectedLocationStore,
    weekDaySelected,
  } = filter;
  //
  const [loading, setLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [tabsData, setTabsData] = useState([]);
  const [layouts, setLayouts] = useState([]);
  //
  const [mounted, setMounted] = useState(false);
  //
  const { listKpis2 } = useSelector((state) => state.filter);
  const payloadCommon = () => {
    return {
      kpis: listKpis2,
      startDate: selectedStart,
      endDate: selectedEnd,
      compareStartDate: compareStart,
      compareEndDate: compareEnd,
      storeCodes: selectedLocationStore,
      days: weekDaySelected,
    };
  };
  const tabs = [
    { tabName: "Operations", value: "operation" },
    { tabName: "Marketing", value: "marketing" },
    { tabName: "Staffing", value: "staffing" },
    { tabName: "Analytics", value: "analytics" },
  ];
  useEffect(() => {
    try {
      if (mounted) {
        const fetchDataOverview = async () => {
          let params = {
            ...payloadCommon(),
            groupByMetricKey: true,
            comparisonYKPIMetricKey: "sls",
          };
          await fetchOverview(params);
        };
        setTimeout(() => {
          fetchDataOverview();
        }, 1000);
        if(listKpis2.length > 0 && listKpis2.includes("sls") && listKpis2.includes("st")) {
          fetchDataTarget({
            ...payloadCommon(),
            client_id: "aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688",
            client_secret: "fp329-polk80s-ye04p1yy-45hx874z06",
            kpiTypes: ["sls", "st"],
            frequency: "daily",
          });
        }
      } else {
        setMounted(true);
      }
    } catch (error) {
      console.log(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    const fetchDataAndHandleErrors = async () => {
      // setLoading(true);
      try {
        const pageName = "operation";
        const res = await fetchData(pageName);
        if(res) {
          const tabData = res;//need this kind of structure which will have all pageName tabData[pageName]
          setTabsData(tabData);
          const layoutPage = res;
          setDataList(layoutPage);
          //
          const defaultLayouts = layoutPage?.map((section) => section.layouts);
          setLayouts(defaultLayouts);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
    fetchDataAndHandleErrors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleTabs = (value) => {
    const layoutPage = tabsData[value];
    setDataList(layoutPage);
    //
    const defaultLayouts = layoutPage?.map((section) => section.layouts);
    setLayouts(defaultLayouts);
  };
  const fetchData = async () => {
    // setLoading(true);
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await getSavedLayouts(accessToken);
      if (response?.data) {
        return response.data;
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      return null;
    }
  };

  const renderHandler = () => {
   

    return (
      <div>
        <FilterBar/>
        <div className={`page-wrapper dashboard-wrapper ${loading ? "loading-active":"loading-unactive"}`}>
          <div className="dashboard-content loader-content">
            <div id="global-loader">
              <div className="whirly-loader"></div>
            </div>
          </div>
        </div>
        {/* / */}
        <div className={`page-wrapper dashboard-wrapper ${!loading ? "loading-active":"loading-unactive"}`}>
          <div className="dashboard-content">
            <div className="tabs-buttons">
              {tabs &&
                tabs.map((item, idx) => (
                  <div
                    className="button-wrappers"
                    key={idx}
                    onClick={() => handleTabs(item.value)}
                  >
                    <div className="styled-button">
                      <span>{item.tabName}</span>
                    </div>
                  </div>
                ))}
             
            </div>

            {/* <FilterBar /> */}
            {Array.isArray(dataList) && dataList?.map((items, index) => (
              <div key={index} className="main-section">
                <div className="dashboard-items">
                  <ResponsiveGridLayout
                    className="layout"
                    layouts={{ lg: layouts[index] || [] }}
                    breakpoints={{ lg: 1200 }}
                    cols={{ lg: 12 }}
                    isDraggable={false}
                    isResizable={false}
                  >
                    {items.components.map((item) => {
                      const Component = React.lazy(() =>
                        import(`../customComponents/${item.name}`).catch(() => {
                          return import(`../customComponents/NotFound.jsx`);
                        })
                      );

                      return Component ? (
                        <div key={item.layoutId}>
                          <Suspense
                            style={{ width: "inherit", height: "inherit" }}
                          >
                            <Component item={item} />
                          </Suspense>
                        </div>
                      ) : (
                        <div key={item.layoutId}>
                          <div style={{ width: "inherit", height: "inherit" }}>
                            Component {item.name} not found.
                          </div>
                        </div>
                      );
                    })}
                  </ResponsiveGridLayout>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return <>{renderHandler()}</>;
};

export default Dashboard;
